import React from "react";
import { notification } from "antd";
import { titleCase } from "./string-helper";
import { Icon } from "../components";
import { RiCloseLine } from "react-icons/ri";

let lastMessage;
let lastMessageClearTimerId;

export const showNotification = (notificationType, message) => {
  const getMessageReactNode = (message) => {
    if (typeof message === "string") {
      return <p>{message}</p>;
    } else {
      return message;
    }
  };

  const notificationArgs = {
    message: titleCase(notificationType),
    description: getMessageReactNode(message),
    duration: 100,
    placement: "topRight",
    closeIcon: (
      <div className={"modal-close-icon"}>
        <Icon type={"close"} size={"md"} icon={<RiCloseLine />} />
      </div>
    ),
    className: "error-notification",
  };

  if (message === lastMessage) {
    return;
  } else if (typeof message === "string") {
    lastMessage = message;
    clearTimeout(lastMessageClearTimerId);
    lastMessageClearTimerId = setTimeout(() => {
      lastMessage = null;
    }, notificationArgs.duration * 1000);
  }

  if (notificationType === "SUCCESS") {
    notification.success(notificationArgs);
  } else if (notificationType === "ERROR") {
    notification.error(notificationArgs);
  } else if (notificationType === "INFO") {
    notification.info(notificationArgs);
  } else if (notificationType === "WARNING") {
    notification.warn(notificationArgs);
  }
};

export const getErrorMessage = (error) => {
  let errorMessage = "An Error Occurred";

  if (
    error.response &&
    error.response.data &&
    error.response.data.result &&
    error.response.data.result.resultDescription
  ) {
    errorMessage = error?.response?.data?.result?.resultDescription;
  } else if (error.response && error?.response?.status) {
    errorMessage = error?.response?.statusText;
  } else if (error.response === undefined) {
    if (error.message === "Network Error") {
      errorMessage = "Please Check Your Internet Connection";
    } else {
      errorMessage = error.message;
    }
  }

  return errorMessage;
};
